import {Vue} from 'ui.vue';
import "citrus.plugins.request";

export let CatalogSection = {
	name: 'CatalogSection',
	store: BX.Citrus.Vuex.store,
	data: function () {
		return {
			pageNum: 1,
			filter: {},
			sort: {
				sort: '',
				order: ''
			},
			pagination: {},
			filterPage: '',
			loading: false,
			paginationSettings: [],
			paginationSettingsSelected: {
				id: 0,
				label: "",
				cookieName: "",
				value: "",
			},
			OpenIndicator: {
				render: createElement => createElement('span', {
					class: {'select_toggle b-filter__icon': true},
					domProps: {
						innerHTML: '<i class="icon icon--arrow-down"></i>'
					},
				})
			},
		};
	},
	mixins: [BX.Citrus.Vue.Component.BulletsRestClient],
	created() {
		BX.addCustomEvent('CatalogSectionDefault:filter', (filter) => {
			this.filterHandler(filter);
		});

		BX.addCustomEvent('CatalogSectionDefault:sort', (sort, order) => {
			this.sortHandler(sort, order);
		});

		if (window.Citrus.hasOwnProperty('PageSettings')) {
			this.paginationSettings = window.Citrus.PageSettings.options;
			this.paginationSettingsSelected = window.Citrus.PageSettings.selected;
		}

		this.getBulletsInfo(this.products, this.bulletsProperty);
	},
	methods: {
		/**
		 * Обработчик для события 'CatalogSectionDefault:filter'
		 *
		 * @param tags
		 * @param url
		 */
		filterHandler(filter) {
			this.filter = Object.assign({}, filter);
			this.pagination.currentPage = 1;
			this.pageNum = 1;
			this.refresh();
		},

		/**
		 * Обработчик для события 'CatalogSectionDefault:sort'
		 *
		 * @param sort
		 * @param order
		 */
		sortHandler(sort, order) {
			this.sort.sort = sort;
			this.sort.order = order;

			this.refresh();
		},

		changedPage: function (option) {
			let pageNumber = parseInt(option.pageNumber);
			this.pageNum = (isNaN(pageNumber) ? 1 : pageNumber);
			this.pagination.currentPage = this.pageNum;
			this.refresh();
			this.scrollToElement();
		},
		async scrollToElement() {

			let slide = this.$refs['catalogTitle'];

			if (!slide) {
				return;
			}

			let top = window.scrollY + slide.getBoundingClientRect().y - this.scrollTopBorder;
			window.scrollTo({
				top: top,
				behavior: 'smooth'
			});
		},
		refresh: function () {

			if (this.loading) {
				return;
			}

			this.loading = true;

			this.$request.setOption({
					componentName: this.componentName,
					action: 'load',
					signedParameters: this.signedParameters,
					data: {
						pageNum: this.pageNum,
						filter: this.filter,
						sort: this.sort
					},
				})
				.send()
				.then((result) => {

					this.products = [];

					if (result.hasOwnProperty('PRODUCTS') && Array.isArray(result.PRODUCTS)) {
						this.products = result.PRODUCTS.slice();
					}

					if (result.hasOwnProperty('PAGINATION')) {
						this.reloadPagination(result.PAGINATION);
					}
					this.getBulletsInfo(this.products, this.bulletsProperty);
					this.loading = false;

					BX.onCustomEvent('CatalogSectionDefault:ajaxLoadDataCompleted', [result.PRODUCTS]);
				})
				.catch((error) => {
					console.log(error);
					this.loading = false;
				});

		},
		reloadPagination(pagination) {
			this.pagination.pagesCount = pagination.NavPageCount;
			this.pagination.recordCount = pagination.NavRecordCount;
		},
		/**
		 * Обработчик кликов по ссылке смены количества элементов
		 * @param selected
		 */
		onSelectPaginationSettings(selected) {
			this.paginationSettingsSelected = selected;
			if (this.paginationSettingsSelected.cookieName && this.paginationSettingsSelected.value) {
				BX.setCookie(
					this.paginationSettingsSelected.cookieName,
					this.paginationSettingsSelected.value,
					{path: "/"}
				);
				window.location.reload();
			}
		}
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases("TPL_CATALOG_SECTION_");
		},
	},
};

export default {CatalogSection};